import { Button, Card } from "react-bootstrap";
import AppLoader from 'components/general/AppLoader';
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useState } from "react";

export default function DeleteModal({ announcement, getAnnouncements, showDeleteButton = false, buttonClassName = '', onDelete, onCancel }) {
  const { user: authUser } = useSelector((x) => x.auth);

  const url = process.env.REACT_APP_URL;

  const [saveLoading, setSaveLoading] = useState(false)
  const [showCard, setShowCard] = useState(false)

  const handleShowCard = () => setShowCard(true)
  const handleCloseCard = () => {
    setShowCard(false)
    if (onCancel) onCancel()
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaveLoading(true);

    try {
      const response = await fetch(`${url}/announcement/${announcement._id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authUser.token}`,
        },
      });

      if (response.status === 200) {
        await response.json();
        toast.success(`Announcement ${announcement.title} deleted successfully`, {
          position: "bottom-left",
        });
        getAnnouncements(); // Refresh the announcement list
        handleCloseCard();
      } else {
        console.log(response);
        toast.error(`Failed to delete announcement ${announcement.title}. Error: ${response.status}`, { position: "bottom-left" });
      }
    } catch (error) {
      console.error(error);
      toast.error(`Failed to delete announcement ${announcement.title} - Error: ${error}`, { position: "bottom-left" });
    } finally {
      setSaveLoading(false);
    }
  }
  return (
    <>
      {showDeleteButton && !showCard ? (
        <Button
          variant="danger"
          className={`mb-1 float-end ${buttonClassName}`.trim()}
          onClick={handleShowCard}
        >
          Delete Announcement
        </Button>
      ) : (
        showCard && (
          <Card className="text-center mt-2 announcements-form-card" data-bs-theme={'dark'}>
            <Card.Header className="announcements-form-header">
              <Card.Title>
                Delete Announcement: <br /> {announcement.name}
              </Card.Title>
            </Card.Header>
            <Card.Body className="announcements-form-body">
              Are you sure you want to delete this announcement?
            </Card.Body>
            <Card.Footer className="announcements-form-footer">
              {saveLoading
                ? (
                  <>
                    <AppLoader />
                    Deleting announcement ...
                  </>
                ) : (
                  <>
                    <Button variant="danger" type='submit' onClick={handleSubmit} className="announcements-action-btn announcements-action-btn--danger">
                      Delete announcement
                    </Button>
                    <Button variant="dark" onClick={handleCloseCard} className="announcements-action-btn announcements-action-btn--neutral">
                      Cancel
                    </Button>
                  </>
                )}
            </Card.Footer>
          </Card>
        )
      )}
    </>
  );
}